import RevenueEntryForm from './RevenueEntryForm';
import Modal from './Modal';

// The quick-entry escape hatch: a thin modal wrapper around the SAME form the
// קטגוריות revenue section uses — opened by the coverage banner on /analysis,
// prefilled with the first missing range. Full management (calendar, list,
// edits) stays on /categories-management.
export default function RevenueQuickAddModal({
  dateFrom = '', dateTo = '', vatRate = 18, onSaved, onClose,
}) {
  return (
    <Modal
      onClose={onClose}
      title="הזנת פדיון"
      size={560}
      // A form with typed revenue figures in it — a stray backdrop click must
      // not discard them.
      closeOnBackdrop={false}
      style={{ maxHeight: '85vh', overflowY: 'auto' }}
    >
    <RevenueEntryForm
      initialFrom={dateFrom}
      initialTo={dateTo}
      vatRate={vatRate}
      onSaved={() => { onSaved?.(); onClose?.(); }}
      onCancel={onClose}
      cancelLabel="סגירה"
      stickyFilterBar={false}
    />
    </Modal>
  );
}
